import { createTheme } from "@mui/material/styles";
import { appThemeFonts } from "./appThemeFonts";

export const appThemeColors = {
  blue: {
    dark: "#0089C2",
    light: "#00AEEF",
  },

  neutral: {
    white: "#FFFFFF",
    black: "#000000",
  },

  background: {
    main: "#F6F9FB",
    paper: "#FFFFFF",
    paper2: "#FAFCFE",
    fill: "#EEF3F8",
    selected: "#E4F4FC",
    soft: "#EDF2F7",
    tint: "#E4F4FC",
    kbd: "#F0F6FB",
    rule: "#F4F7FB",
  },

  border: {
    default: "#E3EBF3",
    secondary: "#E7EEF5",
    strong: "#7E8998",
    dark: "#7E8998",
  },

  text: {
    primary: "#15293A",
    heading: "#0A1F5C",
    muted: "#5C7388",
    faint: "#5F7488",
    faintLight: "#B9CADD",
    lightBlue: "#0077A8",
  },

  semantic: {
    danger: "#C0392B",
  },

  status: {
    ok: { color: "#157A43", background: "#E6F5EE" },
    warn: { color: "#8A5300", background: "#FBF1DC" },
    crit: { color: "#B42318", background: "#FBE4E4" },
    info: { color: "#1552B8", background: "#E6EFFC" },
    neutral: { color: "#48596B", background: "#EEF3F8" },
  },
};

export const appThemeCssVars = {
  "--app-bg-main": appThemeColors.background.main,
  "--app-bg-paper": appThemeColors.background.paper,
  "--app-bg-paper2": appThemeColors.background.paper2,
  "--app-bg-fill": appThemeColors.background.fill,
  "--app-bg-selected": appThemeColors.background.selected,
  "--app-bg-soft": appThemeColors.background.soft,
  "--app-bg-tint": appThemeColors.background.tint,
  "--app-bg-kbd": appThemeColors.background.kbd,
  "--app-bg-rule": appThemeColors.background.rule,

  "--app-border": appThemeColors.border.default,
  "--app-border-secondary": appThemeColors.border.secondary,
  "--app-border-strong": appThemeColors.border.strong,

  "--app-text-primary": appThemeColors.text.primary,
  "--app-text-heading": appThemeColors.text.heading,
  "--app-text-muted": appThemeColors.text.muted,
  "--app-text-faint": appThemeColors.text.faint,
  "--app-text-faint-light": appThemeColors.text.faintLight,

  "--app-blue-dark": appThemeColors.blue.dark,
  "--app-blue-light": appThemeColors.blue.light,

  "--app-neutral-white": appThemeColors.neutral.white,
  "--app-neutral-black": appThemeColors.neutral.black,

  "--app-danger": appThemeColors.semantic.danger,

  "--app-scrollbar-thumb": appThemeColors.text.faintLight,
};

export const appThemeScrollbar = {
  scrollbarWidth: "thin",
  scrollbarColor: `${appThemeColors.text.faintLight} transparent`,
  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: appThemeColors.text.faintLight,
    borderRadius: 999,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: appThemeColors.blue.dark,
      light: appThemeColors.blue.light,
      contrastText: appThemeColors.neutral.white,
    },
    error: {
      main: appThemeColors.semantic.danger,
      contrastText: appThemeColors.neutral.white,
    },
    background: {
      default: appThemeColors.background.main,
      paper: appThemeColors.background.paper,
    },
    text: {
      primary: appThemeColors.text.primary,
      secondary: appThemeColors.text.muted,
      disabled: appThemeColors.text.faint,
    },
    divider: appThemeColors.border.default,
  },
  typography: {
    fontFamily: appThemeFonts.family.ui,
    allVariants: {
      color: appThemeColors.text.primary,
    },
    h1: { color: appThemeColors.text.heading },
    h2: { color: appThemeColors.text.heading },
    h3: { color: appThemeColors.text.heading },
    h4: { color: appThemeColors.text.heading },
    h5: { color: appThemeColors.text.heading },
    h6: { color: appThemeColors.text.heading },
  },
});
